function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14.858 0c.302 0 .593.121.808.338a1.16 1.16 0 010 1.632L2.759 15l12.907 13.03a1.16 1.16 0 010 1.632c-.448.45-1.169.45-1.617 0L.335 15.816a1.158 1.158 0 010-1.632L14.049.338c.224-.225.516-.338.809-.338z",
  fill: "param(fill) #262626",
  fillRule: "nonzero"
});

function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 30",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgChevronLeft;